import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'
import { ConfirmDialogData } from './confirm-dialog-data'

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  title: string
  content: string
  hideButtons = false

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {
    this.title = data.title
    this.content = data.content
    this.hideButtons = data.hideButtons
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog/confirm-dialog.component.ts